import { useTranslation } from 'react-i18next'

import { PencilSimple } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EditAddressTitle = () => {
  const { t } = useTranslation()

  return (
    <Styles.ActionTitleContainer>
      <PencilSimple size={16} />
      <Text type="bodyMRegular">{t('Editar dirección')}</Text>
    </Styles.ActionTitleContainer>
  )
}

export default EditAddressTitle
